import React, { ReactElement, ReactNode } from "react";
import { OverlayTrigger, OverlayTriggerProps, Tooltip } from "react-bootstrap";
import "./UserfulTooltip.scss";
import { Placement } from "react-bootstrap/esm/types";

interface IProps {
    hide?: boolean;
    title: ReactNode;
    children: ReactElement;
    onMouseEnter?: (e) => void;
    onMouseLeave?: (e) => void;
}

export default function UserfulTooltip({
    title,
    children,
    onMouseEnter,
    onMouseLeave,
    ...props
}: IProps & Omit<OverlayTriggerProps, "overlay" | "children">) {
    if (!title) {
        return children;
    }

    if (props.hide) {
        return children;
    }

    return (
        <OverlayTrigger
            placement={props.placement || "top"}
            {...props}
            overlay={
                <Tooltip className="userful-exclusive-tooltip" onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
                    {title}
                </Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    );
}
